package com.crowpay.views.components.project.work.scope

import com.crowpay.*
import com.crowpay.views.components.nav.AppDimensions
import com.crowpay.extensions.handleOne
import com.crowpay.sdk.currentSession
import com.crowpay.sdk.lensUnread
import com.crowpay.sdk.notNullSession
import com.crowpay.utils.*
import com.crowpay.views.components.*
import com.crowpay.views.components.nav.viewIsWide
import com.crowpay.views.screens.common.ProjectLens
import com.crowpay.views.screens.common.ProjectView
import com.crowpay.views.dialogs.*
import com.crowpay.views.theming.*
import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.navigation.dialogScreenNavigator
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import kotlinx.coroutines.launch

fun ProjectView.scopeV3(writer: ViewWriter) = with(writer) {
    col {
        spacing = AppDimensions.sectionIndent
        if (lens == ProjectLens.Contractor) gravity(Align.End, Align.Center) - rowCollapsingToColumn(AppDimensions.normalCollapseWidth) {
            row {
                secondaryButton - button {
                    specCenteredText("+ Scope Set")
                    onClick {
                        dialogScreenNavigator.navigate(
                            NewScopeViewDialog(
                                options = lineItems(),
                                scopeSet = true
                            )
                        )
                    }
                }
                secondaryButton - button {
                    specCenteredText("+ Scope View")
                    onClick {
                        dialogScreenNavigator.navigate(
                            NewScopeViewDialog(
                                options = lineItems(),
                                scopeSet = false
                            )
                        )
                    }
                }
            }
            row {
                tertiaryButton - button {
                    ::enabled {
                        project().state.newNotesAllowed() && lineItems().any { it.state.newNotesAllowed() }
                    }
                    specCenteredText("+ Work Note")
                    onClick {
                        dialogScreenNavigator.navigate(RootCreateItemNote(lineItems().filter { it.state.newNotesAllowed() }))
                    }
                }
                tertiaryButton - button {
                    ::enabled { lineItems().any { it.state.newTasksAllowed() } && project().state.newTasksAllowed() }
                    specCenteredText("+ Work Task")

                    onClick {
                        dialogScreenNavigator.navigate(
                            RootCreateItemTask(
                                lineItems().filter { it.state < LineItemState.Complete }
                            )
                        )
                    }
                }
            }
        }

        col {
            val individualItems = shared {
                lineItems().filter { !it.grouped }
            }

            ::exists {
                individualItems().isNotEmpty()
            }

            subTitle("Work Items")

            if (viewIsWide) indentedCol(Indent.HalfSection) {
                spacing = 0.px
                workItemTableHeader(showNameHeader = true)
                greySeparator()
                col {
                    spacing = 0.px
                    forEachUpdating(individualItems) { item ->
                        col {
                            spacing = 0.px
                            val expand = Property(false)

                            val unread = currentSession.lensUnread { session ->
                                session.lineItems.handleOne { item().wraps } +
                                        session.contractorNotes.isUnread { contractorNotes().filter { it.lineItem == item()._id } } +
                                        session.punchLists.isUnread { punchListItems().filter { it.lineItem == item()._id } } +
                                        session.itemChanges.isUnread { item().changes } +
                                        session.lineItems.creditsIsUnread { setOf(item().wraps) }
                            }

                            val row = workItemTableRow(expand, item, unread = unread, writer = this)

                            launch {
                                JumpTo.LineItem.newTarget(item()._id, row) {
                                    expand.value = true
                                }
                            }

                            onlyWhen { expand() } - renderLineItemDetails(
                                item,
                                contractorNotes.shareFilter { it.lineItem == item()._id },
                                punchListItems.shareFilter { it.lineItem == item()._id },
                                lineItemCompletionMessages.shareFilter { it.lineItem == item()._id },
                                expand,
                                this
                            )
                            greySeparator()
                        }
                    }
                }
            }
            else ListSemantic.onNext - col {
                forEachUpdating(individualItems) { lightSection - lineItemCard(it, lens, this) }
            }
        }

        space()

        col {
            if (viewIsWide) spacing = 0.px
            val fromChangeOrders = scopes.lens { it.filter { it.fromChangeRequest } }
            val customScopes = scopes.lens { it.filter { !it.fromChangeRequest } }
            ::exists { fromChangeOrders().isNotEmpty() || customScopes().isNotEmpty() }

            subTitle("Work Groups")
            ListSemantic.onNext - col {
                if (viewIsWide) spacing = 0.px
                forEachUpdating(customScopes) { scope ->
                    renderScopeView(
                        scope,
                        this
                    )
                }
            }
            ListSemantic.onNext - col {
                if (viewIsWide) spacing = 0.px
                forEachUpdating(fromChangeOrders) { scope ->
                    renderScopeView(
                        scope,
                        this
                    )
                }
            }
            space()
        }
    }
}
